const charts = (() => {
    return {
        bar: barGroup,
        pie: pieChart,
        line: lineChart,
        donut: donutChart,
        waterfall: waterfallChart,
    };
})();
